module.exports = __webpack_public_path__ + "img/icon_circle_fr.13b5f59.svg";